import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { checkAuthToken, getDevoteeId, getaccessToken } from '../../infrastructure/backendService';
import { isNil } from 'lodash';
import SearchDevotee from './searchDevotee/searchDevotee';

const DevoteeService = () => {
const navigate = useNavigate();

   useEffect(()=>{
      if(!checkAuthToken()) {
         navigate('/')
      }
      window.scrollTo(0,0);
   },[getaccessToken()])



    return (
            <Outlet/>
            // <div>
            //    {showSearchDevotee ? <SearchDevotee /> :  <Outlet/>}
            // </div>
    );
};

export default DevoteeService;